var map = {
	"./logo/Azad.png": 885,
	"./logo/IRISA.png": 886,
	"./logo/Mapna.png": 887,
	"./logo/Samseir.png": 888,
	"./logo/day-insurance-gary.png": 889,
	"./logo/day-insurance.png": 890,
	"./logo/dey.png": 891,
	"./logo/diginext-gray.png": 892,
	"./logo/diginext.png": 893,
	"./logo/eastcool-gray.png": 894,
	"./logo/eastcool-rgb.png": 895,
	"./logo/esiminar.png": 896,
	"./logo/irisa-gray.png": 897,
	"./logo/irisa.png": 898,
	"./logo/istcoll.png": 899,
	"./logo/khandevane-gray.png": 900,
	"./logo/khandevane-rgb.png": 901,
	"./logo/khandevaneh.png": 902,
	"./logo/pars.png": 903,
	"./logo/pegah.png": 904,
	"./logo/persis-foods-gray.png": 905,
	"./logo/persis-foods-rgb.png": 906,
	"./logo/refah.png": 907,
	"./logo/shahr-financial-group-gray.png": 908,
	"./logo/shahr-financial-group.png": 909,
	"./logo/shahr.png": 910,
	"./logo/sunich-gray.png": 911,
	"./logo/sunich-rgb.png": 912
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 869;